<template>
    <tr class="center aligned">
        <td> {{ human_datetime(operation.created_at) }}</td>
        <td> {{ operation.number || '-' }} </td>
        <td> {{ operation.customer_note || '-' }} </td>
        <td :class="{negative: operation.core_waybills.length == 0, positive: operation.core_waybills.length != 0 && operation.core_waybills.length == done_core_waybills.length}">
            {{ done_core_waybills.length }} / {{ operation.core_waybills.length }}
        </td>
        <td>
            <span v-if="operation.is_canceled">
                <span>
                    <i class="stop icon"></i class="remove icon">
                    {{ $t('models.attributes.operations.is_canceled') }}
                    <!-- 已取消 -->
                </span>
            </span>
            <span v-else-if="operation.is_done">
                <i class="check icon"></i class="check icon">
                {{ $t('models.attributes.operations.is_done') }}
                <!-- 已完成 -->
            </span>
            <span v-else>
                <i class="play icon"></i class="check icon">
                {{ $t('ui.pages.operations.processing') }}
                <!-- 處理中 -->
            </span>
        </td>
        <td>
            <a :href="operation.original_file_url">{{ operation.original_file_name }}</a>
        </td>
        <td class="center aligned">
            <router-link
                :to="{name: 'show_customer_operation', params: {identity: operation.identity}}"
                class="ui basic primary button"
            >
                {{ $t('ui.general.detail') }}
            </router-link>
        </td>
    </tr>
</template>

<script>
export default {
    name: "CustomerOperationsIndexItem",
    props: {
        operation: Object
    },
    data() {
        return {
        }
    },
    computed: {
        done_core_waybills() {
            return _.filter(this.operation.core_waybills, core_waybill => {
                return core_waybill.is_done == true
            })
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>
